import type { Bounds } from '@/modules/Editor/models/raster/Raster'

/**
 * Given a list of bounds, it returns a comulative bound that includes all passed bounds
 */
export const combineBounds = (bounds: Bounds[]): Bounds | undefined => {
  let combined: Bounds | undefined = undefined

  bounds.forEach((b) => {
    if (combined) {
      combined.topLeft.x = Math.min(combined.topLeft.x, b.topLeft.x)
      combined.topLeft.y = Math.min(combined.topLeft.y, b.topLeft.y)
      combined.bottomRight.x = Math.max(combined.bottomRight.x, b.bottomRight.x)
      combined.bottomRight.y = Math.max(combined.bottomRight.y, b.bottomRight.y)
    } else {
      combined = {
        topLeft: { x: b.topLeft.x, y: b.topLeft.y },
        bottomRight: { x: b.bottomRight.x, y: b.bottomRight.y },
      }
    }
  })

  return combined
}
